<template>
    <div class="test-results">
        <h2 class="title">Uitslag culturele interessetest</h2>
        <p class="description">Hieronder kan je zien hoe hoog je hebt gescoord op de 8 culturele interessegebieden.</p>

        <div class="bar-chart mx-auto my-3">
            <design2021-apprentice-basic-bar-chart-component
                class="mb-5"
                :options="chartOptions"
                :series="series">
            </design2021-apprentice-basic-bar-chart-component>
        </div>

        <div class="toelichting">
            <h2 class="title">Korte uitleg van elk interessegebied</h2>
            <ol>
                <li>
                    Literatuur en verhalen<br />
                    <p>
                        Mensen die hier hoog op scoren, houden van literatuur. Ze lezen relatief veel boeken. Soms
                        schrijven ze zelf verhalen of een gedicht.
                    </p>
                </li>
                <li>
                    Beeldende kunst en creativiteit<br />
                    <p>
                        Mensen die hier hoog op scoren, houden van creatieve uitingen zoals tekenen en schilderen. Ze
                        laten zich graag inspireren door andere kunstenaars en bezoeken tentoonstellingen en musea.
                    </p>
                </li>
                <li>
                    Film en media<br />
                    <p>
                        Mensen die hier hoog op scoren, houden van films en fotografie. Ze kijken graag naar kunstfilms
                        (arthouse), maken bijzondere foto’s en bewerken zelf wel eens een video of film.
                    </p>
                </li>
                <li>
                    Muziek en performance<br />
                    <p>
                        Mensen die hier hoog op scoren, houden van muziek maken. Het liefst doen ze dit samen met
                        anderen. Ook bezoeken ze graag muziekconcerten of theatervoorstellingen.
                    </p>
                </li>
                <li>
                    Architectuur en design<br />
                    <p>
                        Mensen die hier hoog op scoren, houden van design en architectuur. Een beroep als
                        interieuradviseur of architect spreekt hen aan.
                    </p>
                </li>
                <li>
                    Culturele tradities en erfgoed<br />
                    <p>
                        Mensen die hier hoog op scoren, vinden lokale of nationale tradities belangrijk. Zoals carnaval
                        en Koningsdag. Vaak zijn ze geïnteresseerd in geschiedenis van de regio of het land waar ze
                        wonen.
                    </p>
                </li>
                <li>
                    Avontuur en wereldculturen<br />
                    <p>
                        Mensen die hier hoog op scoren, zijn echte wereldreizigers en staan open voor andere culturen.
                        Ze houden van avontuur en willen de wereld ontdekken.
                    </p>
                </li>
                <li>
                    Digitale en sociale media<br />
                    <p>
                        Mensen die hier hoog op scoren, zijn enorm actief op sociale media en houden van het creëren en
                        delen van memes, video's en andere content.
                    </p>
                </li>
            </ol>

            <h2 class="title">Tot slot</h2>
            <p>
                De indeling van 8 soorten cultuur is niet compleet maar geeft wel een goed beeld van de soorten cultuur
                die je kan onderscheiden. Het kan best zijn dat er andere soorten cultuur zijn die voor jou ook
                belangrijk zijn. Zoals spirituele en religieuze tradities. Ook zullen er categorieën zijn die je
                gedeeltelijk aanspreken. Je houdt bijvoorbeeld van muziek maken maar hoeft niet zo nodig op te treden of
                in het middelpunt van de aandacht te staan. Realiseer je daarnaast dat de scores tot stand zijn gekomen
                op basis van een beperkt aantal vragen. De test geeft een indicatie van jouw voorkeren op het gebied van
                cultuur. Deze test is ook bedoeld om jou te laten zien wat voor soorten cultuur er allemaal bestaan en
                welke op dit moment jou het meeste aanspreken.
            </p>
        </div>
    </div>
</template>
<script>
import { getAttributesForKeys, sortResults } from '../../../../helpers/testCenter';
import Design2021ApprenticeBasicBarChartComponent from '../../../common/charts/design-2021-apprentice-basic-bar-chart-component.vue';

const testKey = 'job-personality-cultural-interest-test-2024-12-17';

export default {
    components: { Design2021ApprenticeBasicBarChartComponent },
    props: {
        resultData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            series: [
                {
                    data: sortResults(testKey, this.resultData),
                },
            ],
            chartOptions: {
                chart: {
                    toolbar: {
                        tools: {
                            download: false,
                        },
                    },
                },
                plotOptions: {
                    bar: {
                        barHeight: '100%',
                        distributed: true,
                        columnWidth: '50%',
                        dataLabels: {
                            show: false,
                        },
                    },
                },
                colors: ['#40b4ff'],
                xaxis: {
                    categories: getAttributesForKeys(testKey, 'label'),
                    labels: {
                        style: {
                            fontSize: '13px',
                            fontFamily: 'DM Sans',
                        },
                        rotate: -35,
                    },
                    axisBorder: {
                        show: false,
                    },
                    axisTicks: {
                        show: false,
                    },
                },
                yaxis: {
                    show: false,
                },
                grid: {
                    show: false,
                },
                dataLabels: {
                    enabled: false,
                },
                tooltip: {
                    enabled: false,
                },
                legend: {
                    show: false,
                },
                states: {
                    active: {
                        filter: {
                            type: 'none',
                        },
                    },
                    hover: {
                        filter: {
                            type: 'none',
                        },
                    },
                },
            },
        };
    },
};
</script>

<style scoped lang="scss">
.bar-chart {
    height: 350px;
    max-width: 650px;
}

li {
    font-weight: bold;
    p {
        font-weight: normal;
    }
}
</style>
